import { render, staticRenderFns } from "./TOPAS.vue?vue&type=template&id=407f2496&scoped=true&"
import script from "./TOPAS.vue?vue&type=script&lang=js&"
export * from "./TOPAS.vue?vue&type=script&lang=js&"
import style0 from "./TOPAS.vue?vue&type=style&index=0&id=407f2496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f2496",
  null
  
)

export default component.exports